import * as v from "valibot";
import { createTwoWayMappers } from "@/common/lib/object";
import { WorkspaceViewFilter as CloudWorkspaceViewFilter } from "@/generated/models";

export const workspaceViewFilters = {
  all: {
    type: "all",
    displayText: "All",
    description: "Show all items",
  },
  active: {
    type: "active",
    displayText: "Active",
    description: "Show items where status is not done",
  },
} as const;

export type WorkspaceViewFilterType = keyof typeof workspaceViewFilters;

const workspaceViewFilterMap = {
  all: CloudWorkspaceViewFilter.All,
  active: CloudWorkspaceViewFilter.Active,
} as const satisfies Record<WorkspaceViewFilterType, CloudWorkspaceViewFilter>;

export const [toCloudWorkspaceViewFilter, fromCloudWorkspaceViewFilter] = createTwoWayMappers(workspaceViewFilterMap);

export const WorkspaceFilterSchema = v.object({
  workspaceViewFilter: v.optional(v.picklist(["all", "active"])),
  assigneeFilter: v.optional(v.array(v.string())),
});

export type WorkspaceFilter = v.InferOutput<typeof WorkspaceFilterSchema>;
